import { useState } from "react";
import { toast } from "sonner";
import { Mail } from "lucide-react";
import { api } from "../lib/api";

export const NewsletterForm = ({ compact = false }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.includes("@")) {
      toast.error("Please enter a valid email address.");
      return;
    }
    setLoading(true);
    try {
      const res = await api.subscribe(email);
      if (res.status === "already_subscribed") {
        toast.info("You're already subscribed — deals are on the way!");
      } else {
        toast.success("Welcome aboard! Check your inbox for a confirmation.");
      }
      setEmail("");
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid="newsletter-form" className={compact ? "" : "w-full max-w-md"}>
      <div className="flex flex-col gap-2 sm:flex-row">
        <div className="relative flex-1">
          <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email for weekly deals"
            data-testid="newsletter-email-input"
            className="w-full rounded-xl border border-slate-300 bg-white py-3 pl-9 pr-3 text-sm text-slate-900 placeholder:text-slate-400 focus:border-gold-500 focus:outline-none focus:ring-2 focus:ring-gold-200"
          />
        </div>
        <button
          type="submit"
          disabled={loading}
          data-testid="newsletter-submit-button"
          className="rounded-xl bg-gold-600 px-6 py-3 text-sm font-bold text-white shadow-sm transition-colors hover:bg-gold-700 disabled:opacity-60"
        >
          {loading ? "Joining…" : "Get Deals"}
        </button>
      </div>
      <p className="mt-2 text-xs text-slate-500">
        Weekly deals and trending picks. Unsubscribe anytime. See our{" "}
        <a href="/legal/privacy-policy" className="underline">Privacy Policy</a>.
      </p>
    </form>
  );
};
